/** The message under a reason's statute link when it isn't a web link (see isValidReasonUrl). */
export function UrlError({ valid }: { valid: boolean }) {
  if (valid) return null;
  return (
    <p role="alert" className="mt-1 text-xs text-red-600">
      Link must start with http:// or https://
    </p>
  );
}
